define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "mw-log/Log",
    "mw-utils/Utils",
    "mw-messageservice/MessageService",
    "./PeerSynchronizer"
], function (declare, lang, Log, Utils, MessageService, PeerSynchronizer) {

    //noinspection JSUnusedGlobalSymbols
    return declare([PeerSynchronizer], {

        propertiesSetObserver: function (event) {
            if (event.originator !== this._originator) {
                Object.keys(event.data.newValues).forEach(function (key) {
                    this.updateVersionVector(key, event.target);
                }, this);

                if (this.shouldSync() && this.isReady()) {
                    var message = this.createNewMessage();
                    message.targetId = event.target.getId();

                    var newValues = event.data.newValues;
                    var oldValues = event.data.oldValues;

                    Object.keys(newValues).forEach(function (key) {
                        if (Utils.isImageData(newValues[key])) {
                            var oldValue = oldValues[key];

                            // don't send image values as prop set
                            delete event.data.newValues[key];

                            // only send this message if this synchronizer is the server
                            // (only in tests)
                            if (!this.isClient && Utils.isImageData(oldValue)) {
                                var imageUpdateMessage = this.createNewMessage();
                                imageUpdateMessage.targetId = event.target.getId();
                                imageUpdateMessage.key = key;
                                imageUpdateMessage.newValue =
                                    this.imageDifferencer.computeImageDataDifferences(
                                        oldValue, newValues[key]);
                                this.publish(this.getChannel("imageUpdate"), message);
                            }
                        } else if (newValues[key] === null || newValues[key] === undefined) {
                            delete event.data.newValues[key];
                        }
                    }, this);

                    if (Object.keys(newValues).length > 0) {
                        message.properties = event.data.newValues;
                        message.versionVector = lang.clone(event.target._versionVector);
                        this.publish(this.getChannel(event.type), message);
                    }
                }
            }
        },

        propertiesSetSubscriber: function (message) {
            this.log("propertiesSetSubscriber", message);
            var data = message.data;
            var targetId = data.targetId;

            if (this.manager.hasById(targetId)) {
                try {
                    var node = this.manager.getById(targetId);
                    var key;
                    for (key in data.properties) {
                        if (data.properties.hasOwnProperty(key)) {
                            if (data.properties[key] instanceof Image) {
                                this.imageDifferencer.updatePropertyWithImage(
                                    node, key, data.properties[key]);
                                delete data.properties[key];
                            } else if (!this.shouldUpdateProperties(
                                key, node, message.data.versionVector)) {
                                delete data.properties[key];
                            }

                            if (message.data.versionVector) {
                                this.mergeVersionVectors(key, node, message.data.versionVector);
                            }
                        }
                    }

                    node.setProperties(data.properties, this._originator);
                    this._updateNodePagedData(node);

                } catch (e) {
                    this._error("Error while trying set properties.", message, e);
                }
            }
        },


        shouldUpdateProperties: function (key, node, otherVersionVector) {
            if (this.isClient) {
                return !(node._versionVector && node._versionVector[key] &&
                    (!otherVersionVector || !otherVersionVector[key]));
            } else {
                return !otherVersionVector || !otherVersionVector[key] || !node._versionVector ||
                    !node._versionVector[key] ||
                    node._versionVector[key][this.clientId] <= otherVersionVector[key][
                    this.clientId];
            }
        },

        updateVersionVector: function (key, node) {
            if (this.isClient && (!node._versionVector || !node._versionVector[key])) {
                node._versionVector = node._versionVector || {};
                node._versionVector[key] = {};
                Object.keys(this.syncEnabled).forEach(function (id) {
                    node._versionVector[key][id] = 1;
                });
            } else if (node._versionVector && node._versionVector[key]) {
                node._versionVector[key][this.clientId] += 1;
            }
        },

        mergeVersionVectors: function (key, node, otherVersionVector) {
            if (otherVersionVector && otherVersionVector[key]) {
                if (!node._versionVector || !node._versionVector[key]) {
                    node._versionVector = node._versionVector || {};
                    node._versionVector[key] = {};
                }
                Object.keys(otherVersionVector[key]).forEach(function (id) {
                    node._versionVector[key][id] = Math.max(
                        otherVersionVector[key][id], node._versionVector[key][id] || 1);
                });
            }
        },

        convertNode: function (node) {
            var props = this.inherited(arguments);
            props.versionVectors = node._versionVector;
            return props;
        },

        updateNodeRecursive: function (node, data) {
            if (data.versionVectors) {
                Object.keys(data.versionVectors).forEach(function (key) {
                    this.mergeVersionVectors(key, node, data.versionVectors);
                }, this);
            }
            this.inherited(arguments);
        }
    });
});

